import type { BackupDotState } from '@/utils/backupStatusView';

const STYLE: Record<BackupDotState, { disc: string; glyph: string; text: string }> = {
  green: { disc: 'bg-green-500', glyph: '✓', text: 'text-white' },
  orange: { disc: 'bg-amber-400', glyph: '!', text: 'text-amber-950' },
  red: { disc: 'bg-red-500', glyph: '×', text: 'text-white' },
  gray: { disc: 'bg-gray-400', glyph: '–', text: 'text-white' },
  // Pointillés : le serveur d'état ne répond pas, donc aucune information (ni verte ni grise).
  unknown: {
    disc: 'border-2 border-dashed border-gray-300 bg-transparent',
    glyph: '?',
    text: 'text-gray-200',
  },
};

/**
 * Pastille du voyant des sauvegardes : infobulle seulement (pas de clic). Focusable au clavier pour lire l'infobulle.
 */
export function BackupStatusDot({
  state,
  title,
  label,
}: {
  state: BackupDotState;
  title: string;
  label: string;
}) {
  const s = STYLE[state];
  return (
    <span
      role="img"
      tabIndex={0}
      aria-label={label}
      title={title}
      data-state={state}
      className="inline-flex p-1 sm:p-2 rounded-token-md focus:outline-none focus:ring-2 focus:ring-token-focus focus:ring-offset-token-focus cursor-default"
    >
      <span
        className={`inline-flex h-5 w-5 items-center justify-center rounded-full text-[13px] font-bold leading-none ${s.disc} ${s.text}`}
        aria-hidden="true"
      >
        {s.glyph}
      </span>
    </span>
  );
}
